import { LANGUAGES } from "@/config/languages";
import { useLanguage } from "@/hooks/useLanguage";
import { ActionMenu, Button, ButtonVariant, PopoverSize } from "@enxcs/dap-ui-stratos";
import { FC, useMemo, useRef, useState } from "react";

const SelectLanguage: FC = () => {
  const { language, changeLanguage } = useLanguage();

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);

  const options = useMemo(() => {
    const langList = Object.values(LANGUAGES);
    return langList.map((lang) => ({
      label: lang.name,
      icon: lang.icon,
      onClick: () => {
        changeLanguage(lang.initials);
      },
      disabled: language === lang.initials,
    }));
  }, [changeLanguage, language]);

  return (
    <>
      <Button
        id="select-language-button"
        data-qa-id="select-language-button"
        label={LANGUAGES[language].initials.toUpperCase()}
        leftIcon={LANGUAGES[language].icon}
        elementRef={triggerRef}
        ariaExpanded={isMenuOpen}
        ariaControls="select-language-menu"
        ariaHaspopup="menu"
        onClick={() => setIsMenuOpen((prev) => !prev)}
        variant={ButtonVariant.GHOST}
      />

      {isMenuOpen && (
        <ActionMenu options={options} size={PopoverSize.XS} triggerRef={triggerRef} id="select-language-menu" onClose={() => setIsMenuOpen(false)} />
      )}
    </>
  );
};

export default SelectLanguage;
